import { findSupportedLocale } from './localeCode'
import { i18nLinks } from './data/i18nLinks'

function convertSupportToHelp(url: string, language: string): string | null {
  if (!url || !language) return null
  /* eslint-disable no-nested-ternary */
  const langCode =
    i18nLinks.helpCenterLanguages[language.substring(0, 2).toLowerCase()] ||
    null
  if (!langCode) return null
  let path = url
    .toLowerCase()
    .replace('https://support.docusign.com', '')
    .replace('/login?from=', '')
    .replace('/en/', '/')
    .replace('/guides/', '')
    .replace(/^\//, '')
    .split('?')[0]
  path = i18nLinks.supportToHelpCenterUrls[path]
  if (!path) return null
  return `https://help.docusign.com/${langCode}/bundle/${path}`.replace(
    'bundle/?',
    'bundle?'
  )
}

function languageReplacement(
  language: string,
  info_languages: string,
  info_replacement: string
) {
  const languageTo =
    i18nLinks.replace_language_to[info_languages] ||
    i18nLinks.replace_language_to['_']
  const lang = languageTo[language] || languageTo['_']
  return info_replacement.replace('{lang}', lang)
}

function localizeURL(enUrl: string, language: string): string {
  if (language === 'en') return enUrl
  let url = enUrl
  const radminNewDocUrl = i18nLinks.radminNewDocUrl
  if (url.toLowerCase().indexOf(radminNewDocUrl) === 0) {
    const key = url.replace(radminNewDocUrl, '')
    url =
      i18nLinks.radminSupportDocUrl +
      (i18nLinks.radmin_new_doc_to_guide_map[key] || key)
  }
  const helpUrl = convertSupportToHelp(url, language)
  if (helpUrl !== null) {
    return helpUrl
  }
  let info
  for (const i in i18nLinks.to_be_localized_pages) {
    info = i18nLinks.to_be_localized_pages[i]
    for (const j in info.url_paths) {
      const path = info.base_url + info.url_paths[j].toLowerCase()
      const absUrl =
        url.indexOf('?') > 0 ? url.substring(0, url.indexOf('?')) : url
      if (
        url.toLowerCase().indexOf(path) === 0 &&
        !(info.equal && absUrl.length !== path.length)
      ) {
        const languageTo =
          i18nLinks.replace_language_to[info.languages] ||
          i18nLinks.replace_language_to['_']
        const lang = languageTo[language] || languageTo['_']
        if (info.regex2 && lang.indexOf('en') !== 0) {
          url = url.replace(
            info.regex2,
            languageReplacement(language, info.languages2, info.replacement2)
          )
        }
        return info.equal && lang.indexOf('en') === 0
          ? url
          : url.replace(
              info.regex,
              languageReplacement(language, info.languages, info.replacement)
            )
      }
    }
  }
  for (const ii in i18nLinks.localized_license_pages) {
    info = i18nLinks.localized_license_pages[ii]
    for (const path in info.url_paths) {
      if (url.toLowerCase().indexOf(info.base_url + path.toLowerCase()) === 0) {
        return info.url_paths[path]
      }
    }
  }
  return url
}

function _getLink(
  topicUrl: string,
  language: string | undefined = 'en'
): string {
  let topic = topicUrl
  const lang =
    findSupportedLocale(language) || language.replace('-', '_').toLowerCase()
  if (topic && topic.indexOf('https://') === 0) {
    const result = localizeURL(topic, lang)
    if (lang === 'en' || result.indexOf('https://') === 0) {
      return result
    }
    topic = result // try topic by the result
  }
  const paths =
    i18nLinks.url_paths[topic] || i18nLinks.url_paths[(topic = 'term')]
  const base_url = i18nLinks.baseURL_keys[topic]
    ? i18nLinks.baseURLs[i18nLinks.baseURL_keys[topic]]
    : i18nLinks.baseURLs[lang]
    ? i18nLinks.baseURLs[lang]
    : i18nLinks.baseURLs['_']
  if (paths[lang]) {
    return base_url + paths[lang]
  } else if (paths['_'].indexOf('{lang}') >= 0) {
    const languageTo =
      i18nLinks.replace_language_to[topic] || i18nLinks.replace_language_to['_']
    return (
      base_url +
      paths['_'].replace('{lang}', languageTo[lang] || languageTo['_'])
    )
  }
  return i18nLinks.baseURLs[i18nLinks.baseURL_keys[topic] || '_'] + paths['_']
}

function _getLocalizableURLs(): string[] {
  const localizableList = []
  for (const key in i18nLinks.baseURLs) {
    if (localizableList.indexOf(i18nLinks.baseURLs[key]) < 0) {
      localizableList.push(i18nLinks.baseURLs[key])
    }
  }
  return localizableList
}

export { getLink, getLocalizableURLs }

function getLink(topic: string, language: string | undefined): string {
  try {
    return _getLink(topic, language)
  } catch (ex) {
    return topic
  }
}
function getLocalizableURLs(): string[] {
  try {
    return _getLocalizableURLs()
  } catch (ex) {
    return []
  }
}
